import React, { useEffect, useState } from "react";
import axios from "axios";
import { saveAs } from 'file-saver';
import { useFormik } from "formik";
import JSZip from "jszip";
import { useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { usePermissionGuardRedirect } from "../../../../hooks/usePermissionGuard";
import { GetAssessmentSubmissionUpload, UpdateSubmission } from "../../../../services/CourseService";
import { downloadURL, STUDENT_FILE_DOWNLOAD } from "../../../../utils/Constants";
import PermissionsGate from "../../../../utils/permissionGate";

function SubmissionAndResultStatus({submission_id,assessmentHeader={}}) {
  const { id, subSubId, subId } = useParams();
  const [statusSelected, setStatusSelected] = useState();
  const [statusArr, setStatusArr] = useState([]);
  const searchID = window.location.search;
  const IDs = new URLSearchParams(searchID)
  const intake_id = IDs.get('intake_id');
  let assessment_id = IDs.get('assess_id');
  const [initialStatus, setInitialStatus] = useState("");
  
  useEffect(()=>{
    if (assessment_id?.includes("attempts/list")) {
      assessment_id = assessment_id.split("/")[0]; 
    } else {
      assessment_id = assessment_id;
    }
  },[assessment_id])
  
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const [disabled, setDisabled] = useState(true);
  const [isQuiz, setIsQuiz] = useState(false);
  const [submissionFiles, setSubmissionFiles] = useState([]);
  const [assessmentData, setAssessmentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  
  usePermissionGuardRedirect(['casubmissionresultview']);

  useEffect(() => {
    const data = new FormData();
    data.append("user_id", subId);
    data.append("assessment_id", assessment_id);
    data.append("submission_id", submission_id);
    data.append("intake", intake_id);

    GetAssessmentSubmissionUpload(data)
      .then((res) => {
        let tempStatusArr = [];
        setFile(res.data.document_url);
        setSubmissionFiles(res?.data?.submissionFiles);
        setIsQuiz(res.data?.assignments?.quiz_id);
        setAssessmentData(res.data?.assignments);
        setFileName(res.data.document_url && res.data.document_url.replaceAll("public/", "").replaceAll("home/myaie/public_html/", ""));
        // formik.setFieldValue("File", res.data.document_url && res.data.document_url.replaceAll("public/", "").replaceAll("home/myaie/public_html/", ""));
        setStatusSelected(res.data.status);
        setInitialStatus(res.data.status); 
        let sttArr = res?.data?.status_arr;
        Object.keys(sttArr).map((key, index) => {
          tempStatusArr.push({ value: key, label: sttArr[key], key: key });
        });
        setStatusArr(tempStatusArr);
      })
      .catch((error) => {
        console.log("error getAssessment: ", error);
      });
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      Status: initialStatus, 
      File: "",
      isFileDeleted: 0
    },
    validationSchema: Yup.object({
      Status: Yup.string().required("Status is required"),
      File: Yup.mixed().when("Status", {
        is: (value) => {
          if (value == "open" || isQuiz) {
            return false
          } else {
            if(submissionFiles.length==0){
              return true
            }else{
              return false
            }
          }
        },
        then: Yup.mixed().required("File is required")
      }),
    }),
    onSubmit: (values, { resetForm }) => {
      setDisabled(true)
      setLoading(true)
      let formData = new FormData();
      formData.set("submission_id", submission_id);
      formData.set("document_url", file ? file : "");
      formData.set("status", values.Status);
      formData.set("isFileDeleted", values.isFileDeleted);
      formData.set("intake",id);
      UpdateSubmission(formData)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Updated successfully",
          });
          setDisabled(false)
          setLoading(false)
          history.push(`/courseAdministration/coursesdetails/${intake_id || id}/assessments/open/assigned/submissionsAndResults/${assessment_id || subId}`);
        })
        .catch((error) => {
          console.log("error updateSubmission :", error);
          setDisabled(false)
          setLoading(false)
        });
    },
  });

  return (
    <div className="">
      <div >
        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex">
            <div className="col-md-8" title="Status">
              <label htmlFor="Status">Status* <i className="fal fa-info-circle"></i></label>
              <div className="">
                <div className="form-icon-group">
                  <PermissionsGate scopes={assessmentHeader?.isHybrid ? ["cassgradeassedit"] : ["overidersmart"]} errorProps={{ isDisabled: true }}>
                    <Select
                      className={"form-control custom-select-box" + (formik.errors.Status && formik.touched.Status ? " is-invalid" : "")}
                      name="Status"
                      value={statusArr.filter(function (option) {
                        return option.value == formik.values.Status;
                      })}
                      onChange={(value) => {
                        if (value) {
                          formik.setFieldValue("Status", value.value);
                        } else {
                          formik.setFieldValue("Status", "");
                        }
                      }}
                      onBlur={formik.handleBlur}
                      options={statusArr}
                      maxMenuHeight={175}
                      placeholder={formik.values.Status ? formik.values.Status : "Select"}
                      isClearable
                    />
                  </PermissionsGate>
                </div>
              </div>
            </div>
            <div className="form-group form-group-save-cancel d-flex align-items-end">
              <button disabled={!formik.dirty || !assessmentHeader?.quiz_result_count} className="btn btn-save btn-success" type="submit" title="Save" style={{height:"42px"}}>
                {loading ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-save"></i>}
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SubmissionAndResultStatus;
